import type { IntlShape } from 'react-intl'
import { useIntl } from 'react-intl'

import type { TranslateFn } from './useTranslation.types'

type FormatMessageValues = Parameters<IntlShape['formatMessage']>[1]

export function useTranslation() {
  const intl = useIntl()

  // Single internal cast: the public overloads in `TranslateFn` narrow the
  // return to `string` (plain values) or `ReactNode` (rich values) at call sites.
  const t = ((message: string, values?: FormatMessageValues) =>
    intl.formatMessage({ id: message }, values)) as unknown as TranslateFn

  return {
    t,
    formatDate: intl.formatDate,
    formatNumber: intl.formatNumber,
    formatTime: intl.formatTime,
    formatTimeToParts: (
      value: number | Date,
      options?: Intl.DateTimeFormatOptions
    ) =>
      intl.formatTimeToParts(value, options).reduce(
        (acc, part) => ({
          ...acc,
          [part.type]: part.value,
        }),
        {} as Record<string, string>
      ),
  }
}
